<template>
    <div id="test" ref="test" style="user-select: none;">
      <div ref="content" id="content" class="content" :style="{'width':styleList.width+'px', 'height': styleList.height+'px'}" >

        <div ref="mask"  class="mask" v-show="is_show_mask" :style="'width:'+mask_width+'left:'+mask_left+'height:'+mask_height+'top:'+mask_top" title="选取放大">
       </div>
        <div
          :style="{
            transform: 'scale(' + num + ')',
            position: 'relative',
            width: '100%',
            height: '100%',
            margin:'0 auto',
          }"
          ref="contDiv"
          @mousedown="dragStart"
          @mousewheel="onMouseWheel"
          :title="title"
        >
        <img
            id="bigImg"
            ref="img"
            :style="{ 'max-width': '100%', 'max-height': '100%', 'pointer-events': 'none', 'margin': '0 auto','display': 'block' }"
            :src="img"
            alt=""
          />
        <canvas  ref="mycanvas" class="canvas" id="mycanvas" @mousemove="brushmouseMove"></canvas>
        <!-- <canvas  ref="imgcanvas" class="canvas" id="imgcanvas"></canvas> -->
        <canvas  ref="brushcanvas" class="canvas" id="brushcanvas" 
           @mousemove="brushmouseMove"  @mouseup="brushmouseUp"  @contextmenu.prevent="showContextMenu"
        ></canvas>
        <!--
          v-show="brushcanvasShow"
          @mousedown="dragStart"
          @mousewheel="onMouseWheel"
          @mousemove="brushmouseMove" @mousedown="brushmousemoveDown" @mouseup="brushmouseUp"
          @mousemove="brushmousemove"  @mouseup="stopDrawing" @contextmenu.prevent="showContextMenu" -->
        <!-- 注记-other 弹出-->
              <el-popover
                ref="popover"
                :visible="visible"
                placement="right-start"
                :width="350"
                :show-arrow="false"
                :popper-style="`background: #DDEFF1!important`"
              >
                <template #reference>
                  <div class="popClass"  :style="{'top':toppop+'px','left':leftpop+'px'}" >
                  </div>
                </template>
                <div style="text-align: right; margin: 0;display: flex;justify-content: space-between;">
                    <el-input
                      v-model="otherContent"
                      :rows="3"
                      type="textarea"
                      placeholder="Enter description"
                      style="width: 80%;margin-right: 5px;--el-color-primary:#3AC0CB;"
                      @input="inputFun"
                  />
                  <el-button  style="--el-color-primary:#3AC0CB;background-color: #00838E;color:#ffffff;" size="small" @click.prevent="SaveOther">Save</el-button>
                </div>
              </el-popover>
            </div>
        </div>
        <!-- <vue-context-menu :contextMenuData="contextMenuData" @saveData="saveData"></vue-context-menu> -->
        <div  v-show="showMenu" @blur="hideContextMenu" class="custom-menu">
          <ul>
            <li @click="menuItemClicked('save')">保存</li>
          </ul>
        </div>

      </div>
</template>

<script>
import { openDraw } from '@/utils/drawFundus2.js'
import { createCircleCursorDataURL, getEdges, point2Index, getColor, diffColor, canvasToImage } from '@/utils/brush.js'
// import VueContextMenu from 'vue-contextmenu'
export default {
  name: 'fundusMark',
  components: {
    // VueContextMenu
  },
  props: {
    img: {
      type: String,
      default: '@/assets/imgages/6.jpg'
    },
    styleList: {
      type: Object
    },
    drawData: { /// 新绘图的样式情况
      type: Object,
      default: () => {}
    },
    jsonData: {
      type: Array,
      default: () => []
    },
    markList: { /// 已有框数据
      type: Array,
      default: () => []
    },
    imgStyle: {
      type: Object
    },
    showAllFlag: {
      type: Boolean
    },
    typeList: {
      type: Array,
      default: () => []
    },
    markFlag: {
      type: Boolean
    },
    brushFlag: {
      type: Boolean
    },
    eraserFlag: {
      type: Boolean
    },
    brushSize: {
      type: Number,
      default: 10
    },
    eraserSize: {
      type: Number,
      default: 10
    },
    brushImg: {
      type: String
    }

  },
  watch: {
    markList: {
      handler (newval, oldval) {
        setTimeout(() => {
          console.log(newval)
          this.filterMarkList()
          // openDraw(this.cav, newval, this.drawData, this.imgStyle)
        }, 100)
      },
      deep: true

    },
    typeList: {
      handler (newval, oldval) {
        this.filterMarkList()
      },
      deep: true

    },
    showAllFlag: {
      handler (newval, oldval) {
        console.log('showAllFlag', newval)
        this.filterMarkList()
      },
      deep: true

    },
    drawData: {
      handler (newval, oldval) {
        console.log(newval)
        if (this.markFlag) {
          this.filterMarkList()
        }
      },
      deep: true

    },
    markFlag: {
      handler (newval, oldval) {
        if (newval) {
          /// 开启绘画，需将放大缩小拖拽重置
          console.log(newval)
          this.setDragFlagandNum()
          this.filterMarkList()
        }
      },
      deep: true
    },
    brushFlag: {
      handler (newval, oldval) {
        if (newval) {
          this.brushcanvasShow=true
          this.initBrush()
          this.setDragFlagandNum()
        } else {
          // this.filterMarkList()
        }
      },
      deep: true

    },
    jsonData: {
      handler (newval, oldval) {
          this.dataPoints=newval
      },
      deep: true
    }
  },
  computed: {
    mask_width () {
      return `${Math.abs(this.end_x - this.start_x)}px;`
    },

    mask_height () {
      return `${Math.abs(this.end_y - this.start_y)}px;`
    },

    mask_left () {
      return `${Math.min(this.start_x, this.end_x)}px;`
    },

    mask_top () {
      return `${Math.min(this.start_y, this.end_y)}px;`
    },
    drawType () {
      if (this.brushFlag) {
        return 0
      } else if (this.eraserFlag) {
        console.log(this.drawType)
        return 1
      }
      return 2
    }
  },
  data () {
    return {
      num: 1,
      drawFlag: false,
      imgWidth_T: 0,
      imgHeight_T: 0,
      changedata: {},
      changeindex: 0,
      changeflag: 'push',
      findindex: 0,
      loading: false,
      interval: '',
      width: this.styleList.width,
      height: this.styleList.height,
      imgStyleMark: this.imgStyle,
      list: [],
      title: '向上滾動-放大,向下滾動-縮小,單擊後選區放大,按住空白鍵拖動',
      // markFlag: true,
      is_show_mask: false,
      box_screen_left: 0,
      box_screen_top: 0,
      start_x: 0,
      start_y: 0,
      end_x: 0,
      end_y: 0,
      clientX: 0,
      clientY: 0,
      dragFlag: false,
      visible: false,
      toppop: 300,
      leftpop: 350,
      otherContent: '',
      uuid: null,
      drawing: false, /// brush开始绘画
      
      dataPoints: [], /// 存储每个涂鸦区的坐标数据
      cav: null,
      ctx: null,
      showMenu: false,
      cavbrush: null,

      isDown: false, /// brush鼠标按下事件
      isMove: false, /// brush鼠标移动事件
      isCanUp: false,
      drawPoints: [],
      startPoint: {
          x:0,
          y:0
      },
      imgHistory: [],///图片历史，鼠标up前记录一次
      imgHistoryNext:[],///图片历史，鼠标up时记录一次
      positionHistory:[],//dataPoints的历史,//如果回退,重写新的
      // drawType:0,
      cavbrushCtx: null,
      position: null,
      position2:null,
      canvasImg: new Image(),
      brushcanvasShow: false,///笔刷时打开,橡皮檫和画框时关闭

      cavimg: null,
      cavimgCtx: null,

      nowPoints: [],

      nextFunList: [],///存储后一步points数据，点击上一步后，加入
      nextFunImgHistory:[],//存储后一步img数据，点击上一步后，加入
    }
  },
  created () {
    window.addEventListener('keypress', this.keyfunF, true)
    window.addEventListener('keyup', this.keyupfunF, true)
  },
  beforeUnmount () {
    window.removeEventListener('keypress', this.keyfunF, true)
    window.removeEventListener('keyup', this.keyupfunF, true)
  },
  mounted () {
    
    this.initCanvas() /// / 画布初始化
    this.filterMarkList()
    this.canvasImg=this.brushImg
    /// 全局函数存储绘制数据
    window.changeDataFundus = (flag, data, i) => {
      if (flag === 'push') { /// 插入数据
        this.setVisible(data)
        this.$store.commit('pushFundusMarkdata', data)
        this.$emit('setShowAllFlagOrFlag', data.id)
      } else if (flag === 'delete') { // 删除数据
        const payload = {
          i: i
        }
        this.$store.commit('spliceFundusMarkdata', payload)
      } else if (flag === 'change') { /// 改变数据
        this.setVisible(data)
        setTimeout(() => {
          const payload = {
            i: i,
            data: data
          }
          // this.list.push(data.data)
          this.$store.commit('spliceFundusMarkdata', payload)
        }, 10)
      } else if (flag === 'openvisible') { /// 查找位置
        this.setVisible(data)
      } else if (flag ==="reDrewbrush") {///重绘笔刷图形
        // this.redrewImg()
        // this.reDrawPoints()
      } else if (flag === "hoverbursh") {
        // this.brushmouseMove(data)
      }
    }
  },
  methods: {
    keyupfunF (e) {
      this.dragFlag = false
    },
    /// 按住空白键打开拖拽功能
    keyfunF (e) {
      console.log(e.code)
      if (e.code === 'Space') {
        this.dragFlag = true
      }
    },
    setVisible (data) {
      this.uuid = null
      this.otherContent = ''
      this.visible = false
      setTimeout(() => { /// popover弹出框延后
        /// id===10 other单独处理
        if (data && data.id === 10) {
          this.visible = true
          this.uuid = data.uuid
          this.toppop = data.y
          this.leftpop = data.x + data.w - 3
          if (data.text !== 'other') {
            this.otherContent = data.text.replace('other-', '')
          }
          console.log(data, this.toppop, this.leftpop)
        } else {
          this.visible = false
          this.uuid = null
          this.otherContent = ''
        }
      }, 10)
    },

    /* 画布初始化 */
    initCanvas () {
      this.canvas()
      if (this.markFlag) {
        // openDraw(this.cav, this.list, this.drawData, this.imgStyle)
      }
    },
    async canvas () {
      // 计算使用变量
      // 初始化canvas宽高
      // const img = this.$refs.myimg
      this.cav = ''
      this.cav = document.getElementById('mycanvas')// this.$refs.mycanvas
      this.cav.width = this.imgStyle.width
      this.cav.height = this.imgStyle.height

      this.cavbrush = this.$refs.brushcanvas
      this.cavbrush.width = this.imgStyle.width
      this.cavbrush.height = this.imgStyle.height
      this.cavbrushCtx = this.cavbrush.getContext('2d');

      // this.cavimg = this.$refs.imgcanvas
      // this.cavimg.width = this.imgStyle.width
      // this.cavimg.height = this.imgStyle.height
      // this.cavimgCtx = this.cavimg.getContext('2d');

      const ctx = this.cav.getContext('2d')
      ctx.lineWidth = 2
      this.loading = false
      
    },
    /// 点击放大事件
    fangda (num) {
      num ? this.num += Number(num) : this.num += 0.1
      const mycanvas = this.$refs.mycanvas
      mycanvas.style.cursor = 'zoom-in'
      this.$emit('getNum', this.num)
      // this.dragFlag = true
    },
    // 点击缩小事件
    suoxiao () {
      if (this.num > 1) {
        this.num -= 0.1
        const mycanvas = this.$refs.mycanvas
        mycanvas.style.cursor = 'zoom-out'
        this.$emit('getNum', this.num)
      } else {
        this.dragFlag = false
      }
    },
    handelClick (i) {
      this.b_i = i
    },

    dragStart2 (e) {
      const dragBox = this.$refs.contDiv
      if (this.markFlag) {///画框
        
      } else if (this.brushFlag || this.eraserFlag) {///涂鸦或橡皮檫
        this.brushmousemoveDown(e)
      } else if (this.dragFlag) {///拖拽
        
      } else {//选区放大
        
      }
    },


    // 拖拽事件和选取放大
    dragStart (e) {
      this.start_x = 0
      this.start_y = 0
      this.end_x = 0
      this.end_y = 0
      const dragBox = this.$refs.contDiv
      const mycanvas = this.$refs.mycanvas
      const brushcanvas = this.$refs.brushcanvas
      console.log(this.brushFlag,this.eraserFlag)
      if (!this.brushFlag && !this.eraserFlag) {
        console.log('无笔刷和橡皮檫')
        if (!this.markFlag && this.dragFlag) { // 不可标注和可拖拖拽
          console.log('不可标注和可拖拖拽1')
          mycanvas.style.cursor = 'pointer'
          // console.log(disX, disY)
          dragBox.onmousedown = (e) => {
          //   // 算出鼠标相对元素的位置
          //   console.log(disX, disY)
          //  console.log('不可标注和可拖拖拽2')
            const disX = e.clientX - dragBox.offsetLeft
            const disY = e.clientY - dragBox.offsetTop
            dragBox.onmousemove = (e) => {
            // console.log('不可标注和可拖拖拽3')
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              const left = e.clientX - disX
              const top = e.clientY - disY
              // 移动当前元素
              dragBox.style.left = left + 'px'
              dragBox.style.top = top + 'px'
            // console.log(left, top, '111111111')
            }
          }
          dragBox.onmouseup = (e) => {
          // 鼠标弹起来的时候不再移动
            dragBox.onmousemove = null
            // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
            dragBox.onmouseup = null
          }
        } else if (!this.markFlag && !this.dragFlag) {
          console.log('不可标注和不可拖拽，选区放大')
          mycanvas.style.cursor = 'default'
          dragBox.onmousedown = (e) => {
            this.handleMouseDown(e)
          }
        } else if (this.markFlag && !this.dragFlag) {
          console.log('可标注')
          mycanvas.style.cursor = 'default'
          brushcanvas.style.cursor = 'default'
          // 鼠标弹起来的时候不再移动
          dragBox.onmousemove = null
          // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
          dragBox.onmouseup = null
          // this.filterMarkList()
        }else {
          console.log('不可标注和可拖拖拽4')
          mycanvas.style.cursor = 'default'
          brushcanvas.style.cursor = 'default'
          // 鼠标弹起来的时候不再移动
          dragBox.onmousemove = null
          // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
          dragBox.onmouseup = null
        }
      } else if (this.brushFlag || this.eraserFlag) {
        console.log('有笔刷和橡皮檫')
        this.brushmousemoveDown(e)
      } else {
          console.log('无操作，清空选区放大事件')
          mycanvas.style.cursor = 'default'
          // 鼠标弹起来的时候不再移动
          dragBox.onmousemove = null
          // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
          dragBox.onmouseup = null
      }
    },
    /// 鼠标滚轮放大
    onMouseWheel (e) { /* 当鼠标滚轮事件发生时，执行一些操作 */
      var ev = e || window.event
      var down = true // 定义一个标志，当滚轮向下滚时，执行一些操作
      down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
      if (down) {
        // console.log('鼠标滚轮向下放大---------')
        this.suoxiao()
      } else {
        // console.log('鼠标滚轮向上缩小++++++++++')
        this.fangda()
      }
      if (ev.preventDefault) { /* FF 和 Chrome */
        ev.preventDefault()// 阻止默认事件
      }
      return false
    },
    /* 选区方法 */
    handleMouseDown (event) {
      console.log('选区方法')
      const dragBox = this.$refs.contDiv
      if (!this.markFlag && !this.dragFlag&& !this.brushFlag&& !this.eraserFlag) {
        this.start_x = 0/// 起点x
        this.start_y = 0/// 起点Y
        this.end_x = 0/// ///终点x
        this.end_y = 0/// ///终点Y
        // if (event.target.tagName === 'SPAN') return false

        const boxWidth = dragBox.offsetWidth
        // const boxHeight = dragBox.offsetHeight
        this.is_show_mask = true
        this.start_x = event.offsetX
        this.start_y = event.offsetY
        this.end_x = event.offsetX
        this.end_y = event.offsetY
        // this.start_x = event.clientX
        // this.start_y = event.clientY
        // this.end_x = event.clientX
        // this.end_y = event.clientY
        this.clientX = event.offsetX
        this.clientY = event.offsetY
        dragBox.onmousemove = (e) => {
          this.end_x = e.offsetX
          this.end_y = e.offsetY
        }
        dragBox.onmouseup = (e) => {
          console.log('e', e)
          this.end_x = e.offsetX
          this.end_y = e.offsetY
          this.is_show_mask = false
          dragBox.onmousemove = null
          dragBox.onmouseup = null
          const num = Math.abs(this.end_x - this.start_x) > 10 ? ((boxWidth - Math.abs(this.end_x - this.start_x)) / boxWidth).toFixed(1) : 0
          if (num !== 0) {
            this.fangda(num)
          }
          console.log(this.start_x, this.start_y, this.end_x, this.end_y)
        }
      } else {
        dragBox.onmousemove = null
        dragBox.onmouseup = null
      }
    },

    /// 重置放大缩小拖拽----只可在原比例上画框
    setDragFlagandNum () {
      const mycanvas = this.$refs.mycanvas
      const dragBox = this.$refs.contDiv
      dragBox.style.left = 0 + 'px'
      dragBox.style.top = 0 + 'px'
      // 鼠标弹起来的时候不再移动
      dragBox.onmousemove = null
      // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
      dragBox.onmouseup = null
      dragBox.onmousedown = null
      this.num = 1
      this.$emit('getNum', this.num)
      this.drawFlag = false
      mycanvas.style.cursor = 'default'
    },

    // 筛选需要显示的markList
    filterMarkList () {
      this.brushcanvasShow=false
      /// 监听markList修改后的变化并做显示筛选
      const list2 = []
      if (this.markList.length !== 0 && this.showAllFlag) {
        const list = this.markList
        list.forEach((item,index) => {
          this.typeList.forEach((item2) => {
            if (index < 2) {
              if (item.id === item2.id && item2.flag) {
              list2.push(item)
            }
            }
          })
        })
      }
      this.list = list2

      ////加入笔刷的边缘坐标数据
      for (let i = 0; i < this.jsonData.length; i++){
        this.list.push(this.jsonData[i])
      }
      console.log("ini filterMarkList",this.list)
      openDraw(this.cavbrush, this.list, this.drawData, this.imgStyle)
      this.initDrewImg()
      // this.redrewImg()
      
    },

    /// 保存Other的数据
    SaveOther () {
      this.visible = false
      if (this.uuid && this.otherContent !== '') {
        const payload = {
          uuid: this.uuid,
          otherContent: this.otherContent
        }
        this.$store.commit('changeOtherText', payload)
      }
    },
    judgeLength (str) {
      var len = 0
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i)
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
      }
      return len
    },
    inputFun () {
      const str = this.otherContent
      const len = this.judgeLength(this.otherContent)
      if (len > 80) {
        this.otherContent = str.slice(0, 80 - len)
      }
    },

    /**
     * 笔刷相关函数
     */
    /// 橡皮檫
    drawEraser (e) {
      const x = (e || window.event).offsetX
      const y = (e || window.event).offsetY
      
      if (!this.position) {
        this.position=null
        //通过x,y找出的当前涂抹的图形，并重新修改数据
        for (let j = 0; j < this.dataPoints.length; j++){
          if (x > this.dataPoints[j].xMin.x && x < this.dataPoints[j].xMax.x) {
            if (y > this.dataPoints[j].yMin.y && y < this.dataPoints[j].yMax.y) {
              this.position = j
              break
            }
          }
        }
        console.log('position',this.position)
      }

      const lineWidth = this.eraserSize
      // 橡皮擦圆形半径
      const radius = lineWidth / 2
      const botCtx = this.cav.getContext('2d')
      botCtx.beginPath()
      botCtx.strokeStyle = '#fff'
      for (let i = 0; i < radius * 2; i++) {
        // 勾股定理高h
        const h = Math.abs(radius - i) // i>radius h = i-radius; i<radius  h = radius - i
        // 勾股定理l
        const l = Math.sqrt(radius * radius - h * h)
        // 矩形高度
        const rectHeight = 1
        // 矩形宽度
        const rectWidth = 2 * l
        // 矩形X
        const rectX = x - l
        // 矩形Y
        const rectY = y - radius + i
        botCtx.clearRect(rectX, rectY, rectWidth, rectHeight)
      }
      // this.fliterData(e,this.position)
    },

    // 设置光标样式
    setCircleCursor (radius, color) {
      const mycanvas = this.cav
      const brushCanvas = this.cavbrush
      var dataURL = createCircleCursorDataURL(radius, color)
      mycanvas.style.cursor = 'none' // 先隐藏系统光标
      mycanvas.style.cursor = 'url(' + dataURL + '), none' // 设置自定义光标
      brushCanvas.style.cursor = 'none' // 先隐藏系统光标
      brushCanvas.style.cursor = 'url(' + dataURL + '), none' // 设置自定义光标
    },

    /// 处理当前涂鸦图形的数据
    fliterData (event,position) {
      // const ctx = this.cav.getContext('2d')
      let Imagedata = null
      let { offsetX, offsetY } = event
      console.log('position', position)
      // if (position !== null&&this.eraserFlag) {
      if (position !== null&&position!==undefined) {
        Imagedata = this.ctx.getImageData(0, 0, this.cav.width, this.cav.height, {
          willReadFrequently: true
        })
        const po = this.findEraserandhavePoint(event.offsetX, event.offsetY, Imagedata, position)
        offsetX = po.offsetX
        offsetY = po.offsetY
      } else {
        Imagedata = this.ctx.getImageData(0, 0, this.cav.width, this.cav.height, {
          willReadFrequently: true
        })
      }
      if (Imagedata) {
        const toumingColor = [0, 0, 0, 0]
        // const clickcolor =        this.rgbChangeArr(this.drawData.rgba || 'rgba(0,255,240,0)')/// 当前绘制的颜色
        let clickcolor = getColor(offsetX, offsetY, Imagedata, this.cav.width)
        let datalist =[]
        if (diffColor(clickcolor, toumingColor) !== 0) {///当前鼠标点位置非透明
            this.fingArea(offsetX, offsetY, Imagedata, clickcolor)
            datalist = getEdges(Imagedata) 
        }
        if (datalist.length === 0) {
              if (this.position!==null&&position!==undefined) {///清除了当前位置的所有涂鸦区
                  this.dataPoints.splice(this.position,1)///清除了当前位置坐标
              } else if(diffColor(clickcolor, toumingColor) !== 0) {
                  this.$message.warning('捕捉当前区域失败')
              }
        } else {
                const li = JSON.parse(JSON.stringify(datalist))
                const xlist = li.sort((a, b) => {
                  return a.x - b.x
                })
                const li2 = JSON.parse(JSON.stringify(datalist))
                const ylist = li2.sort((a, b) => {
                  return a.y - b.y
                })
              if (position!==null&&position!==undefined) {
                    const obj = {
                      uuid: this.dataPoints[position].uuid,///唯一标识
                      id: this.dataPoints[position].id,
                      type:'brush',
                      color: this.dataPoints[position].color,
                      text: this.dataPoints[position].text,
                      xMin: xlist[0],
                      yMin: ylist[0],
                      xMax: xlist[xlist.length - 1],
                      yMax: ylist[ylist.length - 1],
                      doctor: this.dataPoints[position].doctor,
                      points: datalist,
                      saveFlag: false,
                      drawPoints:this.drawPoints,///绘制时鼠标移动的点
                    }
                    console.log('change')
                    let pointsHistory = {
                      type:'change',
                      position: position,
                      pointsdata:this.dataPoints[position]
                    }
                    this.dataPoints.splice(position, 1, obj)/// 存储边缘坐标 
                    
                    this.positionHistory.push(pointsHistory)
              } else{
                      const obj = {
                      uuid: Number(new Date().getTime()),///唯一标识
                      id: this.drawData.id,
                      type:'brush',
                      color: this.drawData.color,
                      text: this.drawData.text,
                      xMin: xlist[0],
                      yMin: ylist[0],
                      xMax: xlist[xlist.length - 1],
                      yMax: ylist[ylist.length - 1],
                      doctor: this.drawData.doctor,
                      points: datalist,
                      saveFlag: false,
                      drawPoints:this.drawPoints,///绘制时鼠标移动的点
                  }  
                  console.log('push')
                 
                   this.dataPoints.push(obj)/// 存储边缘坐标 
                   let pointsHistory = {
                      type:'push',
                      position: this.dataPoints.length-1,
                      pointsdata:null
                   }
                   this.positionHistory.push(pointsHistory)
              }
               console.log('this.positionHistory',this.positionHistory)
        }
        
      }
      
      
    },

    /// /通过停止的坐标点x,y找到当前涂抹的区域，改变像素情况，并提取坐标
    fingArea (x, y, imgData, clickColor) {
      /// 1.拿到当前鼠标抬起的坐标点，找到坐标点对应的颜色
      /// 2.对比当前颜色，并修改颜色为识别色
      const stack = [{ x, y }]// 栈防止内存泄露
      const greenColor = [0, 99, 255] /// 识别色
      const s = getColor(x, y, imgData, this.cav.width)
      console.log(s,clickColor,diffColor(s, clickColor))
      while (stack.length > 0) {
        const { x, y } = stack.pop()
        if (x < 0 || x >= this.cav.width || y < 0 || y >= this.cav.height) {
          continue
        }
        const i = point2Index(x, y, this.cav.width)
        const color = getColor(x, y, imgData, this.cav.width)
        const diff = diffColor(color, clickColor)

        if (diff < 10) {
          imgData.data.set(greenColor, i)
          // iList.value.push(i)
          stack.push({ x: x + 1, y })
          stack.push({ x: x - 1, y })
          stack.push({ x, y: y + 1 })
          stack.push({ x, y: y - 1 })
        }
      }
      // 修改非当前区域的其他颜色为透明色--用于计算单个涂鸦区的边缘坐标
      this.setOtherAreaPoint(imgData, greenColor)
      // this.ctx.putImageData(imgData, 0, 0)
    },

    /// 设置非涂鸦区的像素颜色为透明色
    setOtherAreaPoint (imageData, greenColor) {
      const toumingColor = [0, 0, 0, 0]
      /// 对imgData进行循环，当颜色不同时，直接变色，当颜色相同时，判断i的位置（在区域中的位置index中找出最小和最大的坐标）
      for (let i = 0; i < imageData.data.length; i += 4) {
        const nowcolor = [
          imageData.data[i],
          imageData.data[i + 1],
          imageData.data[i + 2],
          imageData.data[i + 3]
        ]
        /// 颜色不等且不为透明色，置为透明色
        if (diffColor(nowcolor, greenColor) !== 0) {
          imageData.data.set(toumingColor, i)
        }else{
          // console.log(i,nowcolor)
        }
      }
    },
    

    /// 提取rgba格式的颜色为数组
    rgbChangeArr (value) { // rgba()数字转为数组
      var arr = []
      const str = value.slice(5)
      const str1 = str.slice(0, str.length - 1)
      arr = str1.split(',')
      const result = arr.map(num => parseInt(num))
      return result
    },

    /// 重绘不规则图形
    reDrawPoints () {
      // this.clearCanvas()
      const ctx2 = this.cav.getContext('2d')
      // console.log(this.dataPoints)
      this.dataPoints=this.jsonData
      // 定义笔画颜色
      for (let i = 0; i < this.dataPoints.length; i++) {
        // if (this.dataPoints[i].saveFlag) {
          ctx2.fillStyle = this.dataPoints[i].color
          this.dataPoints[i].points.forEach(point => {
            ctx2.fillRect(point.x, point.y, 1, 1) // 绘制一个2x2像素的点
          })
        // }
      }
    },
    // 显示hover提示
    hoverText (data, x, y) {
      // this.reDrawPoints()
      // this.cav=this.cavbrush
      const ctx2 = this.cav.getContext('2d')
      ctx2.fillStyle = data.color
      ctx2.fillRect(x, y - 5, ctx2.measureText(`${data.text}(${data.doctor})`).width + 10, 20)
      ctx2.font = '14px "微软雅黑"'
      ctx2.fillStyle = data.id === 2 || data.id === 3 || data.id === 6 || data.id === 7 ? '#fff' : '#000'
      ctx2.fillText(`${data.text}(${data.doctor})`, x + 5, y + 10)
      console.log(ctx2)
      console.log('hoverText')
    },
   

    ///从橡皮檫停留的位置，找出一个涂鸦图形内的点
    findEraserandhavePoint (x,y,Imagedata,position) {
        const randomIntNum = Math.floor(Math.random() * this.dataPoints[position].points.length - 1) + 1
        const len = Math.floor((this.dataPoints[position].points.length - 1) / 2)
        
        const color4 = getColor(this.dataPoints[position].points[randomIntNum].x, this.dataPoints[position].points[randomIntNum].y, Imagedata, this.cavbrush.width)
        const color5 = getColor(this.dataPoints[position].points[len].x, this.dataPoints[position].points[len].y, Imagedata, this.cavbrush.width)
        const color0 = getColor(this.dataPoints[position].xMin.x+1, this.dataPoints[position].xMin.y, Imagedata, this.cavbrush.width)
        const color1 = getColor(this.dataPoints[position].yMin.x, this.dataPoints[position].yMin.y+1, Imagedata, this.cavbrush.width)
        const color2 = getColor(this.dataPoints[position].xMax.x-1, this.dataPoints[position].xMax.y, Imagedata, this.cavbrush.width)
        const color3 = getColor(this.dataPoints[position].yMax.x, this.dataPoints[position].yMax.y-1, Imagedata, this.cavbrush.width)
        // console.log(color0, color1, color2, color3, color4,color5)
        const co = [0, 0, 0, 0]
        if (diffColor(color4, co)>0) {
            return {
                 offsetX: this.dataPoints[position].points[randomIntNum].x ,
                 offsetY: this.dataPoints[position].points[randomIntNum].y
            }
        }
        if (diffColor(color5, co)>0) {
              return {
                 offsetX: this.dataPoints[position].points[len].x ,
                 offsetY: this.dataPoints[position].points[len].y
            }
        }
        if (diffColor(color0, co)>0) {
          return {
            offsetX: this.dataPoints[position].xMin.x+1,
            offsetY: this.dataPoints[position].xMin.y
          }
        }
        if (diffColor(color1, co)>0) {
            return {
              offsetX: this.dataPoints[position].yMin.x ,
              offsetY: this.dataPoints[position].yMin.y+1
            }
        }
        if (diffColor(color2, co)>0) {
            return {
              offsetX: this.dataPoints[position].xMax.x-1,
              offsetY:this.dataPoints[position].xMax.y
            }
        }
        if (diffColor(color3, co)>0) {
            return {
              offsetX: this.dataPoints[position].yMax.x ,
              offsetY:this.dataPoints[position].yMax.y-1
            }
        }
       

        return {
                 offsetX: x ,
                 offsetY:y
        }
    },



    /**
     * 新涂鸦模式
     * 
     * 逻辑：
     * 当选择涂鸦模式时，新建cavas专门用于绘画，保存后写入下一图层
     */
    ///创建涂鸦canvas
    initBrush () {
      this.cavbrush = this.$refs.brushcanvas
      this.cavbrush.width = this.imgStyle.width
      this.cavbrush.height = this.imgStyle.height
      this.cavbrushCtx = this.cavbrush.getContext('2d');

      this.cav= this.$refs.mycanvas
      this.cav.width = this.imgStyle.width
      this.cav.height = this.imgStyle.height
      this.ctx = this.cav.getContext('2d');

      this.clearCanvas()
      this.clearbrushCanvas()
      this.cavbrushCtx.lineCap = 'round'
      this.cavbrushCtx.lineJoin = 'round'
      //鼠标是否按下  是否移动
      this.isDown = false
      this.isMove = false
      //鼠标是否在canvas上抬起
      this.isCanUp = false
      //需要画图的轨迹
      this.drawPoints = []
      //起始点x,y
      this.startPoint = {
          x:0,
          y:0
      }
      //图片历史
      this.imgHistory = [];
      //icon历史
      // let partHistory = [];
      //操作类型
      // this.drawType = 0;
      //画线宽度
      this.setCircleCursor(this.brushSize / 2, 'rgba(255,255,255,0.8)')
      this.redrewImg(this.brushImg)
    },
    brushmousemoveDown (e) {
      console.log('brushmousemoveDown',e)
      if (e.button === 0) {///左键单击
        if (this.brushFlag || this.eraserFlag) {
          this.isDown = true;
          let x = (e||window.event).offsetX;
          let y = (e || window.event).offsetY;
          console.log('鼠标落点',x,y)
          this.startPoint = {x,y};
          this.drawPoints.push([{x,y}]);
          this.cavbrushCtx.strokeStyle = this.drawData.rgba// 'rgba(255,0,0,0.2)';
          this.cavbrushCtx.lineWidth = this.brushSize;
          // this.cavbrushCtx.globalAlpha = 0.7
          this.cavbrushCtx.beginPath();
          this.cavbrushCtx.moveTo(x, y);
          this.position = null
          if (this.eraserFlag) {///橡皮檫之前,记录之前的历史记录
            ///保存历史笔刷记录
            this.imgHistory.push(this.cav.toDataURL('image/png'))
            console.log(this.imgHistory)
          }
      } else {
        this.dragStart(e)
      }
     }
    },

    brushmouseMove (e) {
      // console.log(e)
      if (this.brushFlag || this.eraserFlag) {
        let x = (e || window.event).offsetX;
        let y = (e || window.event).offsetY;
        if (this.isDown) {
          this.isMove = true;
          switch (this.drawType) {
            case 0:
              this.drawCurve(x, y);
              break;
            case 1:
              this.drawEraser(e);
              break;
          }

        }
      }else {
          // const { offsetX, offsetY } = e
          // // console.log('e',e)
          // this.judgePointsPosition(offsetX, offsetY)
      }
    },

    brushmouseUp (e) {        
      this.isCanUp = true
      if (this.isDown) {
        this.upFunction(e)
      }
    },

    upFunction (e) {
      if (this.isCanUp) this.isCanUp = false
      this.isDown = false
      this.isMove = false

      if (this.brushFlag&&this.drawPoints.length>1) {
         
        ///保存上一笔历史笔刷记录
        this.imgHistory.push(this.cav.toDataURL('image/png'))
        console.log(this.imgHistory)
        //把topCan画布生成图片
        let img = new Image()
        img.src = this.cavbrush.toDataURL('image/png')
        const _this = this
        img.onload = function () {
              _this.ctx.drawImage(img, 0, 0)
              if (_this.isCanUp) _this.isCanUp = false
              //鼠标抬起，1.保存图片，计算坐标数据，重新渲染
              _this.fliterData(e, this.position2)  
                  ///保存下一笔历史笔刷记录
        }
        setTimeout(() => {
          _this.imgHistoryNext.push(this.cav.toDataURL('image/png'))
          this.cavbrushCtx.clearRect(0, 0, this.cavbrush.width, this.cavbrush.height)
          this.drawPoints = []
          this.position = null
          this.position2=null
        },1000)
      } else if (this.eraserFlag) {
        //鼠标抬起，1.保存图片，计算坐标数据，重新渲染
        //把topCan画布生成图片
        this.fliterData(e, this.position)
        this.imgHistoryNext.push(this.cav.toDataURL('image/png'))//存储涂鸦完成后的数据
        if (this.isCanUp) this.isCanUp = false
        setTimeout(() => {
          this.cavbrushCtx.clearRect(0, 0, this.cavbrush.width, this.cavbrush.height)
        },1000)
        this.drawPoints = []
        this.position = null
        this.position2=null
      } else {
        this.drawPoints = []
        this.position = null
        this.position2=null
      }
    },
    drawCurve (x, y) {
      console.log('drawCurve')
      this.drawPoints.push({ x, y })
      //清空当前画布内容
      this.cavbrushCtx.clearRect(0, 0, this.cavbrush.width, this.cavbrush.height)
      // this.reDrawImg()
      //必须每次都beginPath  不然会卡
      this.cavbrushCtx.beginPath()
      this.cavbrushCtx.moveTo(this.drawPoints[0].x,this.drawPoints[0].y);
      for (let i = 1; i < this.drawPoints.length; i++){
        this.cavbrushCtx.lineTo(this.drawPoints[i].x,this.drawPoints[i].y);
      }
      this.cavbrushCtx.stroke();
      if (!this.position2) {
        this.position2=null
        //通过x,y找出的当前涂抹的图形，并重新修改数据
        for (let j = 0; j < this.dataPoints.length; j++){
          if (x > this.dataPoints[j].xMin.x && x < this.dataPoints[j].xMax.x) {
            if (y > this.dataPoints[j].yMin.y && y < this.dataPoints[j].yMax.y) {
              this.position2 = j
              break
            }
          }
        }
      }
    },



    /**
   * 清空整个myCanvas
   */
   clearCanvas () {
      const ctx = this.cav.getContext('2d')
      ctx.clearRect(0, 0, this.cav.width, this.cav.height)
      this.cav.onmousedown=null
      this.cav.onmousemove=null
      this.cav.onmousep=null
    },


    /**
   * 清空整个brushCanvas
   */
    clearbrushCanvas () {
      const ctx = this.cavbrush.getContext('2d')
      ctx.clearRect(0, 0, this.cavbrush.width, this.cavbrush.height)
      this.cavbrush.onmousedown=null
      this.cavbrush.onmousemove=null
      this.cavbrush.onmousep=null
    },


    ///mycanvas上绘制图形作为底色背景
    initDrewImg () {
      const ctx = this.cav.getContext('2d')
      ctx.globalAlpha = 0.3
      var image = new Image()
      image.src = this.brushImg
      const _this = this
      console.log(image.src)
      image.onload = function () {
        ctx.drawImage(image, 0, 0)
      }
    },


    // 重绘图片
    redrewImg (imgurl) {
      const ctx = this.cav.getContext('2d')
      this.cav.onmousemove = null
      this.cav.onmouseout = null
      this.cav.onmousedown = null
      this.cav.onmouseup = null
      var image = new Image()
      image.src = imgurl
      const _this = this
      // console.log('redrewImg')
      image.onload = function () {
        ctx.drawImage(image, 0, 0)
      }
    },


    /**
     * 鼠标右键事件
     */
    saveData () {
      // 保存数据
      this.$store.commit('setfundujsonData',this.dataPoints)
      ///右键保存数据,并且
      // this.reDrawPoints()
      this.filterMarkList()
    },

    contextMenu (e, data) {
      e.preventDefault()
      console.log('contextMenu')
      // 右键单击事件（修改菜单显示坐标）
      const x = e.clientX
      const y = e.clientY
      // Get the current location
      this.contextMenuData.axis = { x, y }
      console.log(this.contextMenuData)
      this.$message({ type: 'info', message: '右键点击事件' })
    },
    showContextMenu (event) {
      console.log('contextMenu')
      event.preventDefault() // 阻止默认的上下文菜单弹出
      // 设置菜单位置
      this.setMenuPosition(event)
      this.showMenu = true
    },
    hideContextMenu () {
      this.showMenu = false
    },
    setMenuPosition (event) {
      const menu = this.$el.querySelector('.custom-menu')
      const clickX = event.clientX
      const clickY = event.clientY
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const menuWidth = menu.offsetWidth + 2
      const menuHeight = menu.offsetHeight + 2

      // 设置菜单在鼠标点击位置的正下方，但不能超出窗口边界
      const top = clickY + menuHeight > windowHeight ? clickY - menuHeight : clickY
      const left = clickX + menuWidth > windowWidth ? clickX - menuWidth : clickX

      // 最后设置菜单的定位
      menu.style.top = `${top}px`
      menu.style.left = `${left}px`
      menu.style.display = 'block'
    },
    menuItemClicked (action) {
      // 根据点击的action执行不同的操作
      this.showMenu = false
      if (action === 'save') {
        this.saveData()
      }
      // 其他逻辑
    },


    goBackbrush () {
      if (this.imgHistory.length !== 0) {
        this.clearCanvas()
        const imgurl = this.imgHistory.pop()
        this.redrewImg(imgurl)
        const points_history = this.positionHistory.pop()
       
        if (points_history.type === 'change') {
          let obj = {
            type: 'change',
            position: points_history.position,
            pointsdata:this.dataPoints[points_history.position]
          }
          this.nextFunList.push(obj)
          this.dataPoints[points_history.position] = points_history.pointsdata
         
        } else if (points_history.type === 'push') {
          let obj = {
            type: 'push',
            position: points_history.position,
            pointsdata:this.dataPoints[points_history.position]
          }
          this.nextFunList.push(obj)
          this.dataPoints.splice(points_history.position,1)
        }
      }
    },

    nextFunbrush () {
      if (this.imgHistoryNext.length !== 0) {
          this.clearCanvas()
          const imgurl = this.imgHistoryNext.pop()
          this.redrewImg(imgurl)
          const points_history = this.nextFunList.pop()
          if (points_history.type === 'change') {
            let obj = {
              type: 'change',
              position: points_history.position,
              pointsdata: this.dataPoints[points_history.position]
            }
            this.positionHistory.push(obj)
            this.dataPoints[points_history.position] = points_history.pointsdata
          } else if (points_history.type === 'push') {
            let obj = {
              type: 'push',
              position: points_history.position,
              pointsdata: this.dataPoints[points_history.position]
            }
            this.positionHistory.push(obj)
            this.dataPoints.push(points_history.pointsdata)
            console.log(points_history)
          }
      }
        
    }





  }
}
</script>

<style lang="less" scoped>

#test .content {
    /* //   width: 1200px;
    //   height: 800px; */
      background: none !important;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .activeclass{
        position: absolute;
        top:10px;
        right: 10px;
        width: 87px;
        height: 30px;
        // background-color: red;
        color:#D42525;
        // border: 1px solid #FFFFFF;
        // border-radius: 5px;
        font-size: 18px;
        z-index: 11;
    }
    .spanCircle{
      float:left;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #D42525;
      margin-top: 8px;
    }
.canvas {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
// z-index: 10;
/* width: 100%; */
/* // height: 100%; */
}

.mask {
position: absolute;
background: #409eff;
opacity: 0.4;
z-index: 100;
}
.popClass{
  position: absolute;
  /* top:100px;
  left: 100px; */
}
.custom-menu {
  display: none;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 0;
  border-radius: 0.25rem;
  user-select: none;
}

.custom-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.custom-menu ul li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.custom-menu ul li:hover {
  background-color: #e7e7e7;
}
</style>
